// Set module plugins
import { ApiService, TranslationService } from "webshop-modules";
import { createApp, h } from "vue";
import { ApiPlugin } from "@/plugins/api.plugin";
import { TranslationPlugin } from "@/plugins/translation.plugin";
import { StoragePlugin } from "@/plugins/storage.plugin";
import { IMainHeader } from "@/domain/main-header/entity/MainHeader.interface";
import MainHeader from "@/app/main-header/MainHeader.vue";
import { LanguageSwitchConfigurationProvider, LogoConfigurationProvider, ProfileConfigurationProvider } from "@/domain/main-header/application";
import { QuickSearchConfigurationProvider } from "@/domain/main-header/application/QuickSearchConfiguration.provider";
import { MenuConfigurationProvider } from "@/domain/main-header/application/MenuConfiguration.provider";
import { HeaderLoaderScript } from "@/domain/main-header/entity/HeaderLoaderScript.enum";

// Set initial data
let data: Partial<IMainHeader> = {};
const countryCode = TranslationService.getCountryCode();

const dataScriptPrefix = '-loader-script';
const initialDataScripts: HTMLElement[] = [];
Object.values(HeaderLoaderScript).forEach((script) => {
    initialDataScripts.push(document.querySelector(`[data-js=${ script }${ dataScriptPrefix }]`) as HTMLElement);
});

data = LanguageSwitchConfigurationProvider.provideTo(data);
data = LogoConfigurationProvider.provideTo(data);
data = ProfileConfigurationProvider.provideTo(data);
data = QuickSearchConfigurationProvider.provideTo(data);
data = MenuConfigurationProvider.provideTo(data, countryCode);

Array.prototype.forEach.call(initialDataScripts, (script: any) => {
    if (script && script.parentNode) {
        script.parentNode.removeChild(script);
    }
});

const apiConfiguration = ApiService.getInjectedConfiguration(document, 'mainHeader.js');
const mainHeaderInstance = createApp({
    render: () => h(MainHeader, { data }),
    data() {
        return data;
    }
});

mainHeaderInstance.use(new ApiPlugin(apiConfiguration));
mainHeaderInstance.use(new TranslationPlugin(TranslationService.getConfiguration(document, 'mainHeader.js')));
mainHeaderInstance.use(new StoragePlugin({ poolId: apiConfiguration.clientId }));


mainHeaderInstance.mount('#mainHeader');
